import Ten99Reducers from 'Agent/1099s/ducks';
import AccountReducers from 'Agent/Accounts/ducks';
import AgentLicenseReducer from 'Agent/AgentInformation/ducks';
import AgentDocumentationReducers from 'Agent/AgentDocumentation/ducks';
import ClaimsReducers from 'Agent/Claims/ducks';
import CommissionsReducers from 'Agent/Commissions/ducks';
import PolicyReducers from 'Agent/Policies/ducks';
import agentNewsAdministration from 'AgentNewsAdministration/ducks';
import BeneficiariesReducers from 'Beneficiaries/ducks';
import BOSToolsReducers from 'BOSTools/ducks';
import {connectRouter, LocationChangeAction, RouterState} from 'connected-react-router';
import CoreReducers from 'Core/ducks';
import EnrollmentReducers from 'Enrollment/ducks';
import {combineReducers, Reducer} from 'redux';
import UserReducers from 'Users/ducks';
import SystemAdministrationReducers from 'SystemAdministration/ducks';
import MessagesReducers from 'GenericTexting/ducks';
import AppEntryReducers from 'ApplicationEntry/ducks';

const reducers = {
  ...Ten99Reducers,
  ...AccountReducers,
  user: combineReducers(UserReducers),
  agentNewsAdministration,
  ...ClaimsReducers,
  ...CommissionsReducers,
  ...AgentDocumentationReducers,
  ...EnrollmentReducers,
  ...PolicyReducers,
  ...CoreReducers,
  ...AgentLicenseReducer,
  ...BeneficiariesReducers,
  ...BOSToolsReducers,
  ...SystemAdministrationReducers,
  ...MessagesReducers,
  ...AppEntryReducers,
};

const rootReducer = combineReducers(reducers);
const rootReducerWithHistory = (history: any) => combineReducers({...reducers, router: connectRouter(history)});

export type ReducerState = ReturnType<typeof rootReducer> & {
  router: ReturnType<Reducer<RouterState, LocationChangeAction>>;
};

export default rootReducerWithHistory;
